var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3264,
    height: 820,
    viewBox: "0 0 3264 820",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1190.13 310.377H1190.11H1190.13Z",
    fill: "url(#paint0_radial_559_511)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1190.13 310.377H1190.11",
    stroke: "url(#paint1_radial_559_511)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1511.11 311.877C1525.2 311.877 1536.62 323.285 1536.62 337.377L1536.62 337.476C1536.62 337.509 1536.62 337.542 1536.62 337.575V496.158C1536.62 510.359 1525.2 521.877 1511.11 521.877C1497.03 521.877 1485.62 510.359 1485.62 496.158V337.575L1485.62 337.475C1485.62 337.443 1485.62 337.41 1485.62 337.377C1485.62 323.285 1497.03 311.877 1511.11 311.877ZM1374.13 311.877C1387.72 311.877 1398.8 322.484 1399.58 335.877L1399.62 335.877V429.877H1400.04C1400.04 434.082 1400.69 438.033 1401.88 441.773C1416.06 486.419 1484.92 475.706 1484.97 429.877V496.645C1484.97 501.505 1486.3 506.027 1488.62 509.893C1426.54 544.271 1348.6 500.702 1348.62 429.877V335.877L1348.67 335.877C1349.44 322.484 1360.55 311.877 1374.13 311.877Z",
    fill: "url(#paint2_radial_559_511)",
    stroke: "url(#paint3_radial_559_511)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1762.11 236.877C1776.03 236.877 1787.35 248.027 1787.62 261.878L1787.62 261.877V495.877C1787.35 509.739 1776.03 520.877 1762.11 520.877C1750.45 520.877 1740.63 513.063 1737.59 502.38L1737.62 506.198C1720.42 517.752 1700.35 523.877 1679.6 523.877C1595.28 523.877 1546.11 428.639 1592.49 358.831C1611.48 330.253 1643.62 311.877 1679.57 311.877C1699.52 311.877 1719.68 317.517 1736.28 328.035L1736.62 373.439V261.877C1736.9 248.027 1748.2 236.877 1762.11 236.877ZM1723.47 387.113C1694.2 343.053 1626.53 364.112 1626.51 417.888C1626.51 448.134 1650.35 472.488 1679.6 472.488L1680.87 472.473C1722.61 471.506 1747.28 422.954 1723.47 387.113Z",
    fill: "url(#paint4_radial_559_511)",
    stroke: "url(#paint5_radial_559_511)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1861.13 312.877C1875.22 312.877 1886.62 324.28 1886.62 338.367C1886.62 338.537 1886.62 338.708 1886.62 338.878L1886.62 338.877V494.877C1886.62 495.047 1886.62 495.217 1886.62 495.388C1886.62 509.474 1875.22 520.877 1861.13 520.877C1847.05 520.877 1835.62 509.474 1835.62 495.388C1835.62 495.217 1835.62 495.047 1835.63 494.878L1835.62 494.877V338.877C1835.62 338.708 1835.62 338.537 1835.62 338.367C1835.62 324.28 1847.05 312.877 1861.13 312.877ZM1861.13 234.877C1875.22 234.877 1886.62 246.28 1886.62 260.367C1886.62 274.453 1875.22 285.877 1861.13 285.877C1847.05 285.877 1835.62 274.453 1835.62 260.367C1835.62 246.28 1847.05 234.877 1861.13 234.877Z",
    fill: "url(#paint6_radial_559_511)",
    stroke: "url(#paint7_radial_559_511)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1988.13 231.877C2002.22 231.877 2013.62 243.301 2013.62 257.388C2013.62 257.551 2013.62 257.715 2013.62 257.878L2014.54 257.877L2014.52 447.776C2014.48 466.961 2026.58 471.06 2045.35 468.789C2047.51 468.194 2049.78 467.877 2052.13 467.877C2066.22 467.877 2077.62 479.28 2077.62 493.367C2077.62 506.312 2067.99 517.009 2055.5 518.657L2055.62 519.5C1995.89 528.243 1962.71 494.354 1962.62 446.397V357.877H1947.48C1933.35 357.877 1921.85 346.68 1921.63 332.788L1921.62 332.367C1921.62 318.28 1933.2 306.877 1947.48 306.877H1962.62V257.877C1962.62 257.715 1962.62 257.551 1962.62 257.388C1962.62 243.301 1974.05 231.877 1988.13 231.877ZM2050.62 306.877C2064.47 307.153 2075.62 318.451 2075.62 332.367C2075.62 346.283 2064.47 357.6 2050.62 357.872L2050.62 357.877H2014.9V306.877H2050.62Z",
    fill: "url(#paint8_radial_559_511)",
    stroke: "url(#paint9_radial_559_511)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2500.64 311.877C2511.9 311.877 2522.88 313.555 2533.18 316.698C2543.5 319.82 2553.15 324.408 2561.94 330.185C2579.47 341.76 2593.45 358.178 2601.88 377.654C2607.16 389.816 2610.24 403.171 2610.59 417.074C2610.61 417.509 2610.62 417.947 2610.62 418.387C2610.62 418.528 2610.62 418.668 2610.62 418.808C2610.62 419.164 2610.62 419.52 2610.62 419.877H2610.61L2610.61 420.663C2609.65 478.905 2561.7 525.939 2502.44 526.863L2500.62 526.877H2500.6C2439.73 526.877 2390.6 478.367 2390.62 418.877L2390.63 419.877H2390.62L2390.63 419.282L2390.62 418.888C2390.62 418.559 2390.63 418.231 2390.64 417.905C2390.83 407.424 2392.56 397.209 2395.62 387.615C2398.86 377.399 2403.62 367.884 2409.56 359.261C2421.5 342.015 2438.26 328.443 2457.98 320.309C2471.11 314.872 2485.58 311.877 2500.62 311.877H2500.64ZM2500.62 363.551C2494.5 363.551 2488.64 364.465 2483.15 366.121C2477.67 367.778 2472.52 370.22 2467.88 373.3C2458.56 379.438 2451.2 388.125 2446.88 398.15C2444.43 403.818 2442.91 409.897 2442.5 416.35C2442.58 417.185 2442.62 418.032 2442.62 418.888C2442.62 419.861 2442.57 420.823 2442.47 421.769C2444.02 451.482 2469.35 475.203 2500.62 475.203C2532.58 475.203 2558.84 450.226 2558.86 418.877L2558.85 419.366L2558.85 419.047C2558.77 413.53 2557.88 408.264 2556.3 403.268C2554.62 398.043 2552.2 393.116 2549.09 388.613C2542.86 379.608 2533.94 372.365 2523.47 368.054C2516.47 365.165 2508.81 363.551 2500.62 363.551ZM2610.6 419.877L2610.58 419.878C2609.81 433.269 2598.72 443.877 2585.13 443.877C2571.55 443.877 2560.44 433.251 2559.67 419.878L2558.88 419.877C2559.4 433.686 2570.79 444.725 2584.75 444.725C2598.71 444.725 2610.08 433.686 2610.6 419.877Z",
    fill: "url(#paint10_radial_559_511)",
    stroke: "url(#paint11_radial_559_511)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2659.13 314.877C2669.53 314.877 2678.47 321.106 2682.44 330.036L2682.77 329.877L2733.11 435.31L2782.1 332.805C2785.62 322.939 2795.04 315.877 2806.11 315.877C2820.2 315.877 2831.62 327.301 2831.62 341.387C2831.62 345.211 2830.78 348.837 2829.27 352.091L2829.62 352.262L2757.13 503.992C2753.59 513.835 2744.17 520.877 2733.11 520.877L2732.85 520.877C2730.42 520.881 2727.95 520.514 2725.5 519.724C2717.93 517.356 2711.88 511.554 2709.17 504.142L2637.09 353.22C2634.88 349.452 2633.62 345.068 2633.62 340.387C2633.62 326.301 2645.05 314.877 2659.13 314.877Z",
    fill: "url(#paint12_radial_559_511)",
    stroke: "url(#paint13_radial_559_511)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2964.58 309.877C3025.05 309.877 3068.24 356.127 3069.59 415.021C3069.61 415.467 3069.62 415.916 3069.62 416.366C3069.62 416.555 3069.62 416.742 3069.62 416.929L3069.62 417.877L3069.58 417.857C3068.8 431.25 3057.54 441.877 3043.74 441.877C3043.7 441.877 3043.66 441.877 3043.62 441.877L3043.62 441.877H2954.4C2940.18 441.877 2928.62 430.453 2928.62 416.366C2928.62 402.28 2940.18 390.877 2954.4 390.877L3012.12 390.878C3003.7 372.871 2986.93 361.603 2964.47 361.582C2936.58 361.582 2912.39 386.616 2912.39 417.877L2912.2 417.878C2912.31 427.082 2914.06 435.383 2917.04 442.437C2920.14 449.747 2924.48 455.76 2930.12 460.583C2933.87 463.791 2938.24 466.489 2943.45 468.593C2950.38 471.398 2958.86 473.161 2969.25 473.161H2969.33C2975.77 473.161 2982.98 471.78 2989.85 469.103C2996.71 466.426 3003.18 462.474 3008.2 457.948L3008.82 458.637C3013.36 454.44 3019.44 451.877 3026.11 451.877C3040.2 451.877 3051.62 463.285 3051.62 477.377C3051.62 486.494 3046.84 494.487 3039.65 498.995C3030.31 506.774 3019.75 512.897 3008.52 517.27C2996.08 522.115 2982.81 524.856 2969.25 524.877H2969.2C2955.49 524.877 2942.52 522.858 2930.63 518.928C2918.74 514.976 2907.95 509.09 2898.71 501.632C2892.56 496.661 2887.1 490.988 2882.39 484.826C2876.1 476.582 2871.18 467.424 2867.64 457.757C2863.02 445.164 2860.73 431.68 2860.63 417.878C2860.62 417.763 2860.62 417.649 2860.62 417.536C2860.62 417.317 2860.62 417.097 2860.62 416.877C2860.62 416.708 2860.62 416.537 2860.62 416.366C2860.62 415.88 2860.64 415.397 2860.66 414.918C2862.17 356.753 2908.69 309.877 2964.45 309.877H2964.58Z",
    fill: "url(#paint14_radial_559_511)",
    stroke: "url(#paint15_radial_559_511)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3135.13 312.877C3143.27 312.877 3150.54 316.748 3155.22 322.761C3177.03 311.09 3206.95 308.383 3245.62 322.159L3245.57 322.31C3255.5 325.795 3262.62 335.244 3262.62 346.366C3262.62 360.453 3251.2 371.877 3237.11 371.877C3234.02 371.877 3231.06 371.326 3228.32 370.318L3228.24 370.523C3215.27 365.9 3198.06 361.72 3184.91 365.689C3164.8 371.832 3161.17 398.431 3161.2 405.186C3161.2 407.041 3161 408.85 3160.62 410.594L3160.62 494.877C3160.62 495.047 3160.62 495.217 3160.62 495.387C3160.62 509.474 3149.22 520.877 3135.13 520.877C3121.05 520.877 3109.62 509.474 3109.62 495.387C3109.62 495.217 3109.62 495.047 3109.63 494.878L3109.62 494.877V338.644C3109.62 324.416 3121.05 312.877 3135.13 312.877Z",
    fill: "url(#paint16_radial_559_511)",
    stroke: "url(#paint17_radial_559_511)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2333.06 297.439C2286.98 251.357 2212.27 251.357 2166.18 297.439C2120.1 343.52 2120.1 418.234 2166.18 464.316C2212.27 510.398 2286.98 510.398 2333.06 464.316",
    stroke: "url(#paint18_radial_559_511)",
    strokeWidth: 49,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1290.9 498.877L1205.62 263.112L1120 498.877M1153.12 429.377L1256.12 430.377",
    stroke: "url(#paint19_radial_559_511)",
    strokeWidth: 49,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M410 820C636.437 820 820 636.437 820 410C820 183.563 636.437 0 410 0C183.563 0 0 183.563 0 410C0 636.437 183.563 820 410 820Z",
    fill: "url(#paint20_radial_559_511)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M587.21 273.317C510.725 175.421 369.363 158.064 271.467 234.549C176.007 309.131 157.128 445.404 227.166 542.908",
    stroke: "#06D1DD",
    strokeWidth: 154,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M230.156 276.158C155.392 375.373 175.213 516.411 274.429 591.176C373.644 665.94 514.682 646.118 589.446 546.903",
    stroke: "white",
    strokeWidth: 154,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_559_511",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1190.12 310.877) scale(0.0210037 1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#352CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E32DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_559_511",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1190.12 310.877) scale(0.0210037 1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#352CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E32DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_559_511",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1442.62 416.877) scale(188 210)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#352CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E32DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_559_511",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1442.62 416.877) scale(188 210)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#352CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E32DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_559_511",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1681.12 380.377) scale(213 287)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#352CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E32DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_559_511",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1681.12 380.377) scale(213 287)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#352CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E32DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_559_511",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1861.12 377.877) scale(51 286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#352CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E32DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_559_511",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1861.12 377.877) scale(51 286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#352CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E32DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_559_511",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1999.62 376.377) scale(156 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#352CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E32DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_559_511",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1999.62 376.377) scale(156 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#352CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E32DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_559_511",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2500.62 419.377) scale(220 215)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#352CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E32DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_559_511",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2500.62 419.377) scale(220 215)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#352CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E32DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_559_511",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2732.62 417.877) scale(198 206)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#352CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E32DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_559_511",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2732.62 417.877) scale(198 206)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#352CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E32DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_559_511",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2965.12 417.377) scale(209 215)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#352CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E32DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_559_511",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2965.12 417.377) scale(209 215)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#352CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E32DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_559_511",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3186.12 416.877) scale(153 208)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#352CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E32DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_559_511",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3186.12 416.877) scale(153 208)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#352CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E32DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_559_511",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2249.62 380.877) rotate(-135) scale(236)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#352CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E32DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_559_511",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1205.45 380.995) scale(170.896 235.765)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#352CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E32DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_559_511",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(410 410) scale(820)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#352CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E32DD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bad5558eb8eea22bd52226bc7cf500ce.svg";
export { ForwardRef as ReactComponent };